// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"187":"7f62185e","771":"6a9d96d7","819":"de9b8402"}[chunkId] + ".chunk.js";
};